export default "__VITE_ASSET__9ZwmFVG$__"